import { Button, Modal } from "react-bootstrap"
import "./premium.modal.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import PREMIUM_IMG from "../assets/images/premium-popup.png";
import AI_IMG from "../assets/images/ai-icon-purple.png";
interface PremiumProps {
    isOpen: boolean
    onClose(): void
    onSubmit(): void
}

const PremiumModal: React.FC<PremiumProps> = ({ isOpen, onClose, onSubmit }) => {


    const clickInterest = () => {

        window.open("https://forms.gle/vZY31xmxtjXhGq3PA", "_blank");
    }


    return (
        <Modal show={isOpen} onHide={onClose} centered backdrop="static" >
            <Modal.Body className="premium-control">
                <div className="premium-bg-1"></div>
                <div className="premium-bg-2"></div>
                <FontAwesomeIcon icon={faClose} className="icon-close" onClick={onClose}></FontAwesomeIcon>
                <img src={PREMIUM_IMG} className="premium-img"></img>
                <div className="premium-content-control">
                    <img src={AI_IMG} className="premium-ai-img"></img>
                    <span className="premium-title">ScoutOut AI Premium สมัครตอนนี้! </span>
                    <span className="premium-sub-title">แล้วปล่อยให้ AI ทำหน้าที่เป็นผู้ช่วยมือหนึ่งของคุณ!</span>
                    <span className="premium-detail-1">สอบถามรายละเอียดเพิ่มเติม และลงทะเบียนความสนใจ</span>
                    <Button className="button-std button-form" onClick={clickInterest}>ลงทะเเบียนความสนใจ</Button>
                    <span className="premium-detail-2">หรือติดต่อสอบถามข้อมูลได้ที่ 02-038-2639, 094-924-6162</span>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PremiumModal;